module.exports = __webpack_public_path__ + "img/comment-icon.431023da.svg";